import { useEffect, useState } from "react";
import { dashboardHref } from "../../lib/djangoAppUrl";
import { apiFetch } from "../../lib/http";

export function VerifyEmailPage() {
  const [status, setStatus] = useState<"idle" | "ok" | "error">("idle");
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token") || "";
    if (!token) {
      setStatus("error");
      setMessage("Missing token.");
      return;
    }

    (async () => {
      const resp = await apiFetch("/api/auth/verify-email/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token })
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        setStatus("error");
        setMessage(data?.error || "Verification failed.");
        return;
      }
      setStatus("ok");
      setMessage("Email verified. Redirecting to dashboard…");
      setTimeout(() => (window.location.href = dashboardHref()), 800);
    })();
  }, []);

  return (
    <div className="container py-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <h1 className="h4">Email verification</h1>
          {status === "idle" ? <p className="text-muted mb-0">Verifying…</p> : null}
          {status === "ok" ? <div className="alert alert-success mb-0">{message}</div> : null}
          {status === "error" ? <div className="alert alert-danger mb-0">{message}</div> : null}
        </div>
      </div>
    </div>
  );
}

